<template>
  <div>
    <p>您需要干净的底边吗？ Flexbox/JavaScript 组合可以提供帮助。</p>
    <p>Jamie Perkins 最初写了这篇文章，然后 Janosh Riebesell重写了它，现在我将其移植到这里。</p>
    <p>它完全打乱了顺序，并要求孩子们灵活调整自己的身高，但它确实有效：</p>
    <div id="masonry">
      <v-card
        v-for="item in 30"
        :id="item"
        :key="item"
        color="primary"
      >
        {{ item }}
      </v-card>
    </div>
  </div>
</template>

<script>
  export default {

    mounted() {
      const numCols = 3;
      const colHeights = Array(numCols).fill(0);
      const container = document.getElementById('masonry');
      Array.from(container.children).forEach((child, i) => {
        const order = i % numCols;
        child.style.order = order;
        colHeights[order] += parseFloat(child.clientHeight);
      })
      container.style.height = Math.max(...colHeights) + 'px';
    },
    
  }
</script>

<style lang="scss" scoped>
#masonry {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  max-height: 1000px;
  div {
    flex: 1 0 auto;
    color: white;
    margin: 0 1rem 1rem 0;
    text-align: center;
    font-family: system-ui;
    font-weight: 900;
    font-size: 2rem;
  } 
  @for $i from 1 through 36 { 
    div:nth-child(#{$i}) {
      $h: (random(400) + 100) + px;
      height: $h;
      line-height: $h;
    }
  }
}

</style>